import { useSuspenseQuery, UseSuspenseQueryOptions } from "@tanstack/react-query";
import { Collection, Member } from "@/types";
import { api, ErrorResponse } from "@/utils/api";
import { camelize } from "@/utils/api-helpers";

export const useMembers = (
  options: Omit<UseSuspenseQueryOptions<unknown, ErrorResponse, Collection<Member>>, "queryKey"> = {}
) => {
  return useSuspenseQuery<unknown, ErrorResponse, Collection<Member>>({
    queryKey: ["members"],
    queryFn: async (): Promise<Collection<Member>> => {
      const response = await api.get<Collection<Member>>("/members");
      return camelize(response.data);
    },
    ...options
  });
};
